import { AxiosResponse } from 'axios';
import api from './client';

/**
 * formAiService — calls the admin-gated backend proxy for the Form JSON Editor's
 * natural-language (Thai) assistant. The OpenRouter API key/model live ONLY on the server
 * (backend/internal/server/services/formai); the browser never sees them.
 *
 * Backend route (registered in app.go):
 *   POST /form-ai/edit  → { action, summary, ops|config|error, model, usage }
 */

export interface FormAiUsage {
  promptTokens: number;
  completionTokens: number;
}

export interface FormAiEditResponse {
  action: 'edit' | 'create' | 'error';
  summary?: string;
  // FormEditOp[] — kept loose here so the service stays decoupled from the editor page;
  // the ops are structurally validated when applied (applyFormConfigOps, fail-closed).
  ops?: unknown[];
  config?: Record<string, unknown>;
  error?: string;
  model: string;
  usage?: FormAiUsage;
}

export const formAiService = {
  // POST /form-ai/edit — send the admin's Thai instruction + the config currently in the
  // editor (null = generate a new form). Returns typed edit-ops, a full config, or a
  // refusal, all to be reviewed by the human before saving/publishing.
  edit: async (
    instruction: string,
    currentConfig: unknown | null,
  ): Promise<AxiosResponse<FormAiEditResponse>> => {
    return api.post('/form-ai/edit', { instruction, currentConfig });
  },
};
